import { Offer } from "./offer";
import { OfferSignature } from "./offer-signature";
import { OfferSignatureStatus } from "./offer-signature-status";
import { User } from "./user";

export class OfferSignatureRequested {

    id: number = 0;
    number: number = 0;
    observations!: string;
    //user: User | null | undefined = new User();
    //offerSignature: OfferSignature | null | undefined = new OfferSignature();
    offer: Offer | null | undefined = new Offer();
    status: OfferSignatureStatus = new OfferSignatureStatus();

    offerPdf?: string;
    folio!: string;
}